
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-orange-500 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              会找我
            </h3>
            <p className="text-gray-600 mb-4 leading-relaxed">
              专注于为用户提供值得信赖的电商平台。我们承诺服务直达，为您带来最优质的购物体验。
            </p>
            <div className="flex items-center space-x-4">
              <div className="flex items-center text-gray-600">
                <i className="ri-phone-line mr-2"></i>
                <span>客服热线：010-84855667</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-600 hover:text-orange-500 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/merchant" className="text-gray-600 hover:text-orange-500 transition-colors">
                  商家入驻
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-gray-600 hover:text-orange-500 transition-colors">
                  最新资讯
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-orange-500 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">客户服务</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/help" className="text-gray-600 hover:text-orange-500 transition-colors">
                  帮助中心
                </Link>
              </li>
              <li>
                <Link to="/policy" className="text-gray-600 hover:text-orange-500 transition-colors">
                  退换货政策
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-orange-500 transition-colors">
                  隐私政策
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-orange-500 transition-colors">
                  用户协议
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © 2025 会找我电商平台. 保留所有权利.
          </p>
          <div className="mt-4 md:mt-0">
           
          </div>
        </div>
      </div>
    </footer>
  );
}
